import React from 'react';
import { ModuleContainer } from 'components/common/styles';

const Config: React.FC = () => {
  return (
    <ModuleContainer>
      <div style={{ padding: 16 }}>No global configuration options yet.</div>
    </ModuleContainer>
  );
};

export default Config;
